module.exports = __webpack_public_path__ + "img/应急指挥车.ce14343e.png";